import { Action } from '../actions';

export type UserState = Readonly<{
  id: string;
  email: string;
  sessionId: string;
  roles: string[];
  timezone: string;
}>;

type AuthState = Readonly<{
  user: UserState | null;
  viewMode: 'admin' | 'clinician';
}>;

const initialState: AuthState = {
  user: null,
  viewMode: 'admin',
};

export default function auth(state: AuthState = initialState, action: Action) {
  switch (action.type) {
    case 'LOGIN':
      return {
        ...state,
        user: action.payload.user,
        viewMode: getDefaultViewMode(action.payload.user.roles),
      };
    case 'LOGIN_AWAITING_2FA':
      return {
        ...state,
        user: {
          id: '',
          email: '',
          sessionId: action.payload.sessionId,
          roles: [],
          timezone: '',
        },
      };
    case 'LOGOUT':
      return initialState;
    case 'SET_VIEW_MODE':
      return {
        ...state,
        viewMode: action.payload.viewMode,
      };
    default:
      return state;
  }
}

function getDefaultViewMode(roles: string[]): 'admin' | 'clinician' {
  if (roles.includes('ROLE_ADMIN')) return 'admin';
  if (
    roles.includes('ROLE_COACH') ||
    roles.includes('ROLE_PHYSICIAN') ||
    roles.includes('ROLE_FOUNDER')
  )
    return 'clinician';
  return 'admin';
}
